import axios from "axios";
import {
  AdminAuthControllerApi,
  AdminMealControllerApi,
  AdminMenuControllerApi,
  AdminMenuItemControllerApi,
  AdminPlanControllerApi,
  AdminUserControllerApi,
  AdminUserMenuControllerApi,
  AllergenControllerApi,
  ZoneControllerApi,
  AdminDeliveryControllerApi,
  AdminSubscriptionControllerApi,
  MedicalConditionControllerApi,
  AdminDriverControllerApi,
  AdminPlanOptionControllerApi,
  AdminFileControllerApi,
  MealControllerApi,
  AdminAffiliateControllerApi,
  AdminInvoiceControllerApi,
  AdminIngredientControllerApi,
  AdminAccountControllerApi,
  AdminDeliveryFeeControllerApi,
  AdminDietitianControllerApi,
  AdminAccountReportControllerApi,
  AdminAddressControllerApi,
  AdminHubControllerApi,
  AdminPartnerControllerApi,
  AdminAreaControllerApi,
  LockedDaysControllerApi,
  AdminDiscountControllerApi,
  PriceOfferControllerApi,
  AdminSelectionControllerApi,
  AdminHealthMetricsControllerApi,
  AdminMembershipControllerApi,
  DislikeControllerApi,
  AdminAdminUserControllerApi,
} from "./client";
import { getAccessToken, migrateOldSession, refreshAccessToken } from "../utils/tokenStore";

// Dedicated axios instance for all API calls — avoids polluting the global axios default
const apiAxios = axios.create();

// Request interceptor — attach in-memory access token to every request
const attachAuthToken = async (config: any) => {
  const token = getAccessToken();
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
};

apiAxios.interceptors.request.use(attachAuthToken, (error) => Promise.reject(error));

// Fallback 401 response interceptor — handles clock skew and server-side token revocation
const handle401 = async (error: any) => {
  const originalRequest = error.config;
  if (
    error.response?.status === 401 &&
    !originalRequest._retry &&
    !originalRequest.url?.includes("/admin/auth/refresh")
  ) {
    originalRequest._retry = true;
    const newToken = await migrateOldSession() || await refreshAccessToken();
    if (newToken) {
      originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
      return apiAxios(originalRequest);
    }
  }
  return Promise.reject(error);
};

apiAxios.interceptors.response.use((response) => response, handle401);

export default {
  UserMenu: new AdminUserMenuControllerApi(undefined, undefined, apiAxios),
  Auth: new AdminAuthControllerApi(undefined, undefined, apiAxios),
  User: new AdminUserControllerApi(undefined, undefined, apiAxios),
  AdminUser: new AdminAdminUserControllerApi(undefined, undefined, apiAxios),
  Plan: new AdminPlanControllerApi(undefined, undefined, apiAxios),
  PlanOption: new AdminPlanOptionControllerApi(undefined, undefined, apiAxios),
  AdminMeal: new AdminMealControllerApi(undefined, undefined, apiAxios),
  Meal: new MealControllerApi(undefined, undefined, apiAxios),
  MenuItem: new AdminMenuItemControllerApi(undefined, undefined, apiAxios),
  Menu: new AdminMenuControllerApi(undefined, undefined, apiAxios),
  Allergen: new AllergenControllerApi(undefined, undefined, apiAxios),
  Zone: new ZoneControllerApi(undefined, undefined, apiAxios),
  Delivery: new AdminDeliveryControllerApi(undefined, undefined, apiAxios),
  Subscription: new AdminSubscriptionControllerApi(undefined, undefined, apiAxios),
  MedicalCondition: new MedicalConditionControllerApi(undefined, undefined, apiAxios),
  Driver: new AdminDriverControllerApi(undefined, undefined, apiAxios),
  File: new AdminFileControllerApi(undefined, undefined, apiAxios),
  Affiliate: new AdminAffiliateControllerApi(undefined, undefined, apiAxios),
  Invoice: new AdminInvoiceControllerApi(undefined, undefined, apiAxios),
  Ingredients: new AdminIngredientControllerApi(undefined, undefined, apiAxios),
  Account: new AdminAccountControllerApi(undefined, undefined, apiAxios),
  AccountReport: new AdminAccountReportControllerApi(undefined, undefined, apiAxios),
  DeliveryFee: new AdminDeliveryFeeControllerApi(undefined, undefined, apiAxios),
  Dietitian: new AdminDietitianControllerApi(undefined, undefined, apiAxios),
  Address: new AdminAddressControllerApi(undefined, undefined, apiAxios),
  Hub: new AdminHubControllerApi(undefined, undefined, apiAxios),
  Partner: new AdminPartnerControllerApi(undefined, undefined, apiAxios),
  Area: new AdminAreaControllerApi(undefined, undefined, apiAxios),
  LockedDays: new LockedDaysControllerApi(undefined, undefined, apiAxios),
  Discount: new AdminDiscountControllerApi(undefined, undefined, apiAxios),
  PriceOffer: new PriceOfferControllerApi(undefined, undefined, apiAxios),
  Selection: new AdminSelectionControllerApi(undefined, undefined, apiAxios),
  HealthMetrics: new AdminHealthMetricsControllerApi(undefined, undefined, apiAxios),
  Membership: new AdminMembershipControllerApi(undefined, undefined, apiAxios),
  Dislike: new DislikeControllerApi(undefined, undefined, apiAxios),
};
